import { useCallback } from 'react'
import { httpsCallable, HttpsCallableResult } from 'firebase/functions'
import { functions } from '@/config/firebase'
import { useToast } from '@/contexts/ToastContext'

/**
 * Firebase Callable 関数を呼び出す共通 hook。
 * エラー発生時は自動的にトーストで赤色アラートを表示する。
 *
 * @param name - Firebase Functions の関数名
 * @returns [call, loading] - call(data?) で呼び出し、戻り値は Result または null
 */
export function useCallable<TData = unknown, TResult = unknown>(name: string) {
  const { showError } = useToast()

  const call = useCallback(
    async (data?: TData): Promise<HttpsCallableResult<TResult> | null> => {
      try {
        const fn = httpsCallable<TData, TResult>(functions, name)
        return await fn(data)
      } catch (error: any) {
        const message: string =
          error?.message ?? `${name} の処理中にエラーが発生しました。`
        showError(message)
        return null
      }
    },
    [name, showError],
  )

  return call
}
